// src/components/about/OurTeamSection.jsx
import React from 'react';
import { Linkedin, Mail, ChevronRight, Stethoscope, Award, HeartPulse } from 'lucide-react';

// Import team images
import doc1 from '../../assets/Doctorimages/Rohith1.png';
import doc2 from '../../assets/Doctorimages/Zwalitha1.png';
import doc3 from '../../assets/Doctorimages/S Pushpika1.png';
import doc4 from '../../assets/Doctorimages/A V Krishna Kishore1.png';
import doc5 from '../../assets/Doctorimages/Janiki Ram1.png';
import doc6 from '../../assets/Doctorimages/Hima Anurag1.png';
import doc7 from '../../assets/Doctorimages/Dr Mounica1.png';
import doc8 from '../../assets/Doctorimages/M Srinivasa Raju1.png';
import doc9 from '../../assets/Doctorimages/M V Subba Rao1.png';
import doc10 from '../../assets/Doctorimages/PVNR Prasad1.png';
import doc11 from '../../assets/A-founder-img.png';
import doc12 from '../../assets/Doctorimages/T Geetha Bhavani1.png'
import doc13 from '../../assets/Doctorimages/T Sunitha1.png'
import doc14 from '../../assets/Doctorimages/G Ramana Reddy1.png'
import doc15 from '../../assets/Doctorimages/Bhargava1.png'
import doc16 from '../../assets/Doctorimages/GK Swamy1.png'
import doc17 from '../../assets/Doctorimages/D Naga Pavani1.png'
import doc18 from '../../assets/Doctorimages/Dr S Krishnan Chaitanya1.png'
import doc19 from '../../assets/Doctorimages/Dimple Ashika1.png'
import doc20 from '../../assets/Doctorimages/Gnanadeep.png'
import doc21 from '../../assets/Doctorimages/T Seema Kumari1.png'
import doc22 from '../../assets/Doctorimages/D Ram Chaitanya1.png'
import doc23 from '../../assets/Doctorimages/Divya Teja1.png'
const teamData = {
  directors: [
    { name: "Dr. GEETHA BHAVANI THOTA", role: "Additional Director", spec: "MD Anaesthesia", image: doc12 },
    { name: "Dr. KRISHNA KISHORE AKULA", role: "Director", spec: "MBBS, MS & MCh (Urology)", image: doc4 },
    { name: "Dr. SUNITHA TOLETI", role: "Additional Director", spec: "MBBS, MD (Micro), PGI", image: doc13 },
    { name: "Dr. RAMANA REDDY GUNNAM REDDY", role: "Director", spec: "MBBS, MD., DM-NIMS (Neurology)", image: doc14 },
    { name: "Dr. VENKATA SUBBA RAO MUNAGANURI", role: "Director", spec: "MBBS, MD (Pulmonologist)", image: doc9 },
    { name: "GUNTAKA BHARGAVA RAMI REDDY", role: "Additional Director", spec: "B.Tech (Mechanical)", image: doc15 },
  ],
  doctors: [
    { name: "Dr. P V N R Prasad", role: "Doctor", spec: "BAMS, MD(AYU), P.hd", image: doc10 },
    { name: "Dr. G K SWAMY", role: "Doctor", spec: "BAMS, MD(AYU), Ex-Director NARIP(CCRAS)", image: doc16 },
    { name: "Dr. T SEEMA KUMARI", role: "Doctor", spec: "BAMS, MD(Ayu)", image: doc21 },
    { name: "Dr. KOSURU MOUNICA", role: "Doctor", spec: "BAMS (CNF)", image: doc7 },
    { name: "Dr. K. GNANADEEP", role: "Doctor", spec: "BAMS, MD(Ayu)", image: doc20 },
    { name: "Dr. D. RAM CHAITANYA", role: "Doctor", spec: "BHMS", image: doc22 },
    { name: "Dr. SINGAMPALLI ZWALITHA", role: "General Surgeon", spec: "MBBS, MS (Gen Surg)", image: doc2 },
    { name: "Dr. M SRINIVASA RAJU", role: "Psychiatry", spec: "MBBS, DPM (Podiatric Medicine)", image: doc8 },
    { name: "Dr. D NAGA PAVANI", role: "Paediatrician", spec: "MBBS, D.ch., Paediatrics", image: doc17 },
    { name: "Dr. SUNKARA KRISHNA CHAITANYA", role: "Dentist", spec: "MBBS, MDS Maxillofacial", image: doc18 },
    { name: "Dr. S PUSHPIKA", role: "Dentist", spec: "MBBS, MDS Orthodontics", image: doc3 },
    { name: "Dr. V HIMA ANURAG", role: "Gynecologist", spec: "MBBS, MS OBG", image: doc6 },
  ],
  physio: [
    { name: "Dr. R ROHITH", role: "Physio Doctor", spec: "MPT Neurology", image: doc1 },
    { name: "Dr. DIMPLE ASHIKA", role: "Physio Doctor", spec: "MPT", image: doc19 },
    { name: "Dr. M JANAKI RAMAN", role: "Physio Doctor", spec: "BPT, PGDOFSIM", image: doc5 },
    
  ],
  pharm: [
    { name: "GUNTAKA DIVYA TEJA", role: "B.Pharm, M.Pharm(Pharmaceutical Analysis & Quality Assurance)", spec: "Pharmacist", image: doc23 },

  ]

};

const TeamMemberCard = ({ member }) => (
  <div className="group relative bg-white/70 backdrop-blur-sm rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-emerald-100/50 flex flex-col">
    <div className="relative aspect-square overflow-hidden bg-emerald-50">
      {member.image ? (
        <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-emerald-100/30">
          <Stethoscope className="w-12 h-12 text-emerald-200" />
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    </div>
    
    <div className="p-5 flex-grow flex flex-col">
      <h3 className="text-lg font-bold text-gray-900 leading-tight group-hover:text-emerald-700 transition-colors">
        {member.name}
      </h3>
      <p className="text-xs font-bold text-emerald-600 uppercase tracking-wider mt-1">
        {member.role}
      </p>
      <div className="mt-auto pt-3 border-t border-emerald-50">
        <p className="text-sm text-[#0B2A2C] font-bold leading-relaxed">
          {member.spec}
        </p>
      </div>
    </div>
  </div>
);

export default function OurTeamSection() {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-emerald-50/30 to-amber-50 px-6 md:px-12 lg:px-20 py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/natural-paper.png')] opacity-20 pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-emerald-600 font-bold tracking-widest uppercase text-sm">Expert Care</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B2A2C]">Our Medical Leadership</h2>
          <div className="h-1.5 w-24 mx-auto bg-gradient-to-r from-emerald-600 to-teal-600 rounded-full"></div>
        </div>

        {/* Hero Section: Managing Director */}
        <div className="bg-white/40 rounded-[3rem] p-8 md:p-12 mb-24 border border-white/60 shadow-xl backdrop-blur-md">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="relative shrink-0">
              <div className="absolute -inset-4 bg-emerald-600/10 rounded-full animate-pulse"></div>
              <img
                src={doc11}
                alt="Dr. V. K. Subrahmanyeswara Rao"
                className="w-56 h-56 md:w-72 md:h-72 rounded-full border-8 border-white shadow-2xl relative z-10 object-cover"
              />
              <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-2xl shadow-lg z-20">
                <Award className="w-8 h-8 text-amber-500" />
              </div>
            </div>

            <div className="text-center lg:text-left space-y-4">
              <div className="inline-block px-4 py-1 bg-emerald-100 text-emerald-700 rounded-full text-sm font-bold mb-2">
                Managing Director
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Dr. SUBRAHMANYESWARA RAO  <br className="hidden md:block"/>VENKATA KANAKA SIRIGUDI
              </h3>
              <p className="text-emerald-700 font-semibold text-lg italic">
                BAMS, MD(AYU) Gold Medalist
              </p>
              <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
                A visionary in Ayurvedic medicine, Dr. Subrahmanyeswara Rao combines traditional wisdom with gold-standard academic excellence to lead our holistic healing mission.
              </p>
              {/* <div className="flex justify-center lg:justify-start gap-4 pt-4">
                 <button className="bg-[#0B2A2C] text-white px-8 py-3 rounded-full hover:bg-emerald-800 transition-all flex items-center gap-2">
                   View Profile <ChevronRight className="w-4 h-4"/>
                 </button>
              </div> */}
            </div>
          </div>
        </div>

        {/* Directors Grid */}
        <div className="mb-20">
          <h4 className="flex items-center gap-3 text-2xl font-bold text-gray-800 mb-8 border-l-4 border-emerald-500 pl-4">
            Board of Directors
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6">
            {teamData.directors.map((m, i) => <TeamMemberCard key={i} member={m} />)}
          </div> 
        </div>

        {/* Medical Specialists Grid */}
        <div className="mb-20">
          <h4 className="flex items-center gap-3 text-2xl font-bold text-gray-800 mb-8 border-l-4 border-teal-500 pl-4">
            Specialist Doctors
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
            {teamData.doctors.map((m, i) => <TeamMemberCard key={i} member={m} />)}
          </div>
        </div>

        {/* Physiotherapy Section */}
        <div className="mb-20">
          <h4 className="flex items-center gap-3 text-2xl font-bold text-gray-800 mb-8 border-l-4 border-amber-500 pl-4">
            Physiotherapy Doctors
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {teamData.physio.map((m, i) => <TeamMemberCard key={i} member={m} />)}
          </div>
        </div>

        <div className="mb-20">
          <h4 className="flex items-center gap-3 text-2xl font-bold text-gray-800 mb-8 border-l-4 border-amber-500 pl-4">
            Pharmacist
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {teamData.pharm.map((m, i) => <TeamMemberCard key={i} member={m} />)}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-20">
          <div className="inline-flex flex-col items-center">
             <p className="text-gray-500 mb-6 font-medium">Want to consult with our specialists?</p>
             <a
               href="/BookNow"
               className="group flex items-center gap-3 bg-[#0B2A2C] text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-emerald-900 transition-all shadow-xl hover:shadow-emerald-200/50"
             >
               Book a Consultation
               <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
             </a>
          </div>
        </div>
      </div>
    </section> 
  );
}